import React from "react";
import {rootActions, useAppDispatch, useAppSelector} from "../../DAL/store";
import { PluginSortStatusEnum} from "../../enums";
import ArrowIcon from "../../../../ui/svg/common/arrow";
import {ToggleShowSortOptions} from "../../services/logic-helper";
import {useWindowSize} from "../../../../domain/common";
import { TABLET_BREAKPOINT_END} from "../../../../domain/animations/animations-provider";

interface IPluginsSortOptionsProps {
    //close: Function;
}

export const PluginsSortOptions = (props : IPluginsSortOptionsProps) => {

    const ShowSortChoices = useAppSelector((store) => store.ShowSortChoices);
    const PluginSortStatus = useAppSelector((store) => store.PluginSortStatus);
    const size = useWindowSize();

    const dispatch = useAppDispatch();
    const OnClickOption = (value : number) => {

        dispatch(
            rootActions.main({
                PluginSortStatus:value,
                ShowSortChoices:!ShowSortChoices
            })
        )

    }
    return (
            <>
                <button type={"button"} onClick={() => ToggleShowSortOptions(ShowSortChoices,dispatch)} className="absolute bottom-0 flex items-center justify-start cursor-pointer inline-block" style={{color:"#C8C8C8"}}>
                    <span>Sort Plugins: </span>
                    {PluginSortStatus === PluginSortStatusEnum.ProductNameAZ &&
                        <span className="pl-1">A-Z</span>
                    }
                    {PluginSortStatus === PluginSortStatusEnum.ProductNameZA &&
                        <span className="pl-1">Z-A</span>
                    }
                    {PluginSortStatus === PluginSortStatusEnum.Popular &&
                        <span className="pl-1">Popular</span>
                    }
                    {PluginSortStatus === PluginSortStatusEnum.IncludedInPlan &&
                        <span className="pl-1">Essential first</span>
                    }
                    <div className="pl-1.5">
                        <ArrowIcon
                            width="9px"
                            color="white"
                            title="Arrow Down"
                            rotationAngle={0}
                        />
                    </div>
                </button>
                {ShowSortChoices &&
                    <div className="sort-plugins-container">
                        <ul className="pl-4">
                            <li className="p-2 cursor-pointer">
                                <button type="button" onClick={() => OnClickOption(PluginSortStatusEnum.Popular)}>Popular</button>
                            </li>
                            {size.width !== undefined && size.width > TABLET_BREAKPOINT_END &&
                                <li className="p-2 cursor-pointer">
                                    <button type="button" onClick={() => OnClickOption(PluginSortStatusEnum.IncludedInPlan)} >Plugins in Essential first</button>
                                </li>
                            }
                            <li className="p-2 cursor-pointer">
                                <button type="button" onClick={() => OnClickOption(PluginSortStatusEnum.ProductNameAZ)}>Plugin name: A-Z</button>
                            </li>
                            <li className="p-2 cursor-pointer">
                                <button type="button" onClick={() => OnClickOption(PluginSortStatusEnum.ProductNameZA)} >
                                    Plugin name: Z-A
                                </button>
                            </li>

                        </ul>
                    </div>
                }
            </>
    )
};